import { api } from './client'

export const turnsApi = {
    getState:     (gameId)              => api.get(`/games/${gameId}/turns/state`),
    roll:         (gameId)              => api.post(`/games/${gameId}/turns/roll`, {}),
    holdDie:      (gameId, dieId)       => api.post(`/games/${gameId}/turns/hold`, { die_id: dieId }),
    bankRolls:    (gameId)              => api.post(`/games/${gameId}/turns/bank`, {}),
    scoreCategory:(gameId, categoryId)  => api.post(`/games/${gameId}/turns/score`, { category_id: categoryId }),
    getScoresheet:(gameId)              => api.get(`/games/${gameId}/turns/scoresheet`),
}
